// extracted by mini-css-extract-plugin
export default {"adminObjectSearch":"AdminObjectSearch_adminObjectSearch__PFfnk"};